// Where a chart's break mark goes (Chart.jsx). Plain JS, no JSX, so the server's
// test suite can import it (server/hub/test-hub.mjs).

/**
 * The bucket index a break falls at in this mode, or -1 when the series does
 * not reach it. A break names the week it starts (`x`, a Monday) and the day the
 * change took effect (`date`); a month or quarter is the one holding that day.
 */
export function breakIndex(all, brk, mode) {
    const day = String(brk.date || brk.x)
    const key =
        mode === 'week'
            ? String(brk.x || brk.date)
            : mode === 'month'
              ? day.slice(0, 7)
              : `${day.slice(0, 4)}-Q${Math.floor((Number(day.slice(5, 7)) - 1) / 3) + 1}`
    const i = all.findIndex((p) => String(p.x) >= key)
    // At the first bucket the line would sit on the axis with nothing before it:
    // the series does not reach back across the change, so there is no break.
    return i > 0 ? i : -1
}
